<template>
    <MapPopup
        v-if="activated"
        v-bind="$attrs"
        :image-src="imageSrc"
        :caption="caption"
        :initial-open="pendingOpen"
    />
    <div
        v-else
        ref="rootRef"
        class="map-popup-wrapper relative w-full cv-map-slot min-h-[280px] lg:min-h-[400px]"
        data-client-ready="1"
    >
        <div
            class="relative w-full h-full min-h-[280px] lg:min-h-[400px] bg-gray-200 rounded-xl overflow-hidden shadow-sm cursor-pointer group"
            role="button"
            tabindex="0"
            aria-label="Open interactive map"
            @click="activate(true)"
            @keydown.enter.prevent="activate(true)"
            @keydown.space.prevent="activate(true)"
        >
            <div
                class="absolute inset-0 bg-cover bg-center transition-opacity"
                data-alt="Schematic map of Czech Republic highway network"
                :style="previewStyle"
            />
            <div class="absolute bottom-4 right-4 bg-white/90 backdrop-blur px-4 py-2 rounded-lg text-xs font-bold text-gray-600 shadow-sm border border-gray-200">
                {{ caption }}
            </div>
        </div>
    </div>
</template>

<script>
import { computed, defineAsyncComponent, onBeforeUnmount, onMounted, ref } from 'vue';

const MapPopup = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'map-popup' */ './MapPopup.vue')
);

export default {
    name: 'LazyMapPopup',
    inheritAttrs: false,
    components: { MapPopup },
    props: {
        imageSrc: { type: String, default: '' },
        caption: { type: String, default: '' },
    },
    setup(props) {
        const activated = ref(false);
        const pendingOpen = ref(false);
        const rootRef = ref(null);
        let externalTriggerEl = null;

        const previewStyle = computed(() =>
            props.imageSrc ? { backgroundImage: `url('${props.imageSrc}')` } : {}
        );

        function onExternalTrigger(event) {
            event.preventDefault();
            activate(true);
        }

        function activate(open = false) {
            pendingOpen.value = open;
            activated.value = true;
        }

        onMounted(() => {
            externalTriggerEl = document.getElementById('open-map-popup-link');
            externalTriggerEl?.addEventListener('click', onExternalTrigger);
        });

        onBeforeUnmount(() => {
            externalTriggerEl?.removeEventListener('click', onExternalTrigger);
            externalTriggerEl = null;
        });

        return {
            activated,
            pendingOpen,
            rootRef,
            previewStyle,
            activate,
        };
    },
};

</script>
